import graphqlClient from '@/graphql/graphql-client';
import { useMutation } from '@tanstack/react-query';
import {
  InsertTaskManagerItemDocument,
  type InsertTaskManagerItemMutationVariables,
} from '@/graphql/generated/graphql';

export type TaskManagerItemInsertInput = InsertTaskManagerItemMutationVariables;

export const useInsertTaskManagerItem = () => {
  const mutation = useMutation({
    mutationKey: ['insert-task-manager-item'],
    mutationFn: (variables: InsertTaskManagerItemMutationVariables) =>
      graphqlClient.request(InsertTaskManagerItemDocument, variables),
  });

  return {
    ...mutation,
    insertTaskManagerItem: mutation.mutate,
    insertTaskManagerItemAsync: mutation.mutateAsync,
  };
};

export const INSERT_TASK_MANAGER_ITEM_MUTATION = InsertTaskManagerItemDocument;
